import { useState, useEffect } from 'react';

/**
 * useGeoDetect hook — fetches the visitor's geolocation from the API.
 *
 * Usage:
 *   const { geo, isLoading } = useGeoDetect();
 *   // geo = { country, countryCode, city, timezone, ip } | null
 *
 * Example use cases:
 *   - Show currency in local currency based on countryCode
 *   - Show country-specific announcement banner
 *   - Redirect to localized subdomain (e.g., de.marketplace.com)
 *   - Pre-fill country field in registration form
 */
const useGeoDetect = () => {
  const [geo, setGeo] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setIsLoading(true);

    fetch('/api/geo/detect')
      .then(res => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then(data => {
        if (!cancelled) setGeo(data);
      })
      .catch(err => {
        if (!cancelled) setError(err.message);
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => { cancelled = true; };
  }, []);

  return { geo, isLoading, error };
};

export default useGeoDetect;
